
import { Input } from "@/components/ui/input";
import { Tables } from "@/integrations/supabase/types";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type Profile = Tables<"profiles">;

interface ProfileInfoProps {
  profile: Profile;
  isEditing: boolean;
  isOwnProfile: boolean;
  onEdit: () => void;
  onSave: (event: React.FormEvent<HTMLFormElement>) => void;
  isPending: boolean;
}

export const ProfileInfo = ({ 
  profile, 
  isEditing, 
  isOwnProfile, 
  onSave,
  isPending 
}: ProfileInfoProps) => {
  const getRoleBadgeStyle = (role: string) => {
    if (role === 'production') {
      return 'bg-[#403E43] text-white hover:bg-[#403E43]/90';
    }
    return 'bg-[#0FA0CE] text-white hover:bg-[#0FA0CE]/90';
  };

  return (
    <form onSubmit={onSave} className="flex flex-col items-center gap-2 max-w-md mx-auto py-4">
      <div className="space-y-4 w-full text-center">
        {isEditing && isOwnProfile ? (
          <>
            <Input 
              name="full_name"
              defaultValue={profile?.full_name || ''}
              className="font-medium text-center text-xl"
            />
            <Button 
              type="submit" 
              disabled={isPending}
              className="mt-4"
            >
              <Save className="mr-2" />
              Save Changes
            </Button>
          </>
        ) : (
          <>
            <p className="font-medium text-2xl">{profile?.full_name}</p>
            <Badge 
              className={cn(
                "text-sm px-4 py-1 font-medium capitalize",
                getRoleBadgeStyle(profile?.role || '')
              )}
            >
              {profile?.role || 'Employee'}
            </Badge>
          </>
        )}
      </div>
    </form>
  );
};
